<template>
  <div
    class="main-content"
    :class="{
      'main-content--left-sidebar-present': leftSidebar,
      'main-content--right-sidebar-present': rightSidebar
    }"
  >
    <transition name="fade">
      <img
        v-if="$route.params.subsectionId !== '63d0b92ef896654418ce6ec9' && $route.params.subsectionId !== '63d0b93cf896654418ce6eca' && backgroundAssetType === 'image' && backgroundImage"
        class="main-content__background"
        :key="backgroundImage"
        :src="`${$store.state.assetsPath}${backgroundImage}`"
      >
      <video
        v-if="$route.params.subsectionId !== '63d0b92ef896654418ce6ec9' && $route.params.subsectionId !== '63d0b93cf896654418ce6eca' && backgroundAssetType === 'video' && backgroundImage"
        :key="backgroundImage"
        class="main-content__background"
        :src="`${$store.state.assetsPath + backgroundImage}`"
        autoplay
        muted
        loop
      ></video>

      <div v-if="$route.params.subsectionId === '63d0b92ef896654418ce6ec9' || $route.params.subsectionId === '63d0b93cf896654418ce6eca'">
        <img
          v-if="backgroundAssetType === 'image' && backgroundImage"
          class="main-content__background"
          :key="backgroundImage"
          :src="`${$store.state.assetsPath}${backgroundImage}`"
        >
        <div v-if="$route.params.subsectionId === '63d0b92ef896654418ce6ec9'" class="ocean-sarai">
          <router-link to="/live/63d0750df896654418ce6ec6/subsection/63d3107da8fb467f4bfa69e5?parentSubsectionId=63d0b92ef896654418ce6ec9"></router-link>
          <router-link to="/live/63d0750df896654418ce6ec6/subsection/63d32d544a5719663d499097?parentSubsectionId=63d0b92ef896654418ce6ec9"></router-link>
          <router-link to="/live/63d0750df896654418ce6ec6/subsection/63d32d704a5719663d499098?parentSubsectionId=63d0b92ef896654418ce6ec9"></router-link>
          <router-link to="/live/63d0750df896654418ce6ec6/subsection/63d32d944a5719663d499099?parentSubsectionId=63d0b92ef896654418ce6ec9"></router-link>
        </div>
        <div v-if="$route.params.subsectionId === '63d0b93cf896654418ce6eca'" class="marina-sarai">
          <router-link to="/live/63d0750df896654418ce6ec6/subsection/63d32a994a5719663d49908f?parentSubsectionId=63d0b93cf896654418ce6eca"></router-link>
          <router-link to="/live/63d0750df896654418ce6ec6/subsection/63d32aba4a5719663d499090?parentSubsectionId=63d0b93cf896654418ce6eca"></router-link>
        </div>
      </div>
    </transition>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: ['backgroundImage', 'left-sidebar', 'right-sidebar'],

  computed: {
    backgroundAssetType () {
      if (this.backgroundImage && this.backgroundImage.split('.').pop() === 'mp4') {
        return 'video'
      } else {
        return 'image'
      }
    }
  },
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
@import "node_modules/tiny-slider/src/tiny-slider";

.main-content {
  width: 192rem;
  height: 100rem;
  position: absolute;
  top: 0;
  left: 0;

  &__background {
  height: 100%;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;
}

  &--right-sidebar-present {
    width: 152rem;
  }

  &--left-sidebar-present {
    width: 152rem;
  }

  .main--right-sidebar-present.main--left-sidebar-present {
    width: 152rem;
  }
}

.ocean-sarai {
  align-content: center;
  display: flex;
  height: 100%;
  position: absolute;
  width: 100%;

  a {
    flex: 1;
  }
}

.marina-sarai {
  align-content: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: absolute;
  width: 100%;

  a {
    flex: 1;
  }
}
</style>